import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import CloudscapeAppLayout from '@amzn/awsui-components-core/app-layout';
import Header, { STICKY_HEADER_STYLE, HEADER_WRAPPER_ID } from 'src/components/organisms/Header';
import { usePageViewMetric } from 'src/hooks/usePageViewMetric';

import '@amzn/awsui-global-styles/polaris.css';

/**
 * AppLayout — minimal page chrome for routes that don't need a side nav.
 *
 * Uses the plain Cloudscape `AppLayout` (not `AppLayoutToolbar`) so neither
 * the navigation nor the tools toolbar strip is rendered. Routes that DO
 * need a side nav should use `AppLayoutWithNav` instead.
 */
const AppLayout: FC = () => {
  usePageViewMetric();

  return (
    <>
      <div id={HEADER_WRAPPER_ID} style={STICKY_HEADER_STYLE}>
        <Header />
      </div>
      <CloudscapeAppLayout
        headerSelector={`#${HEADER_WRAPPER_ID}`}
        navigationHide={true}
        toolsHide={true}
        content={<Outlet />}
        // Cloudscape requires this prop even when both panels are hidden.
        // Strings are never rendered to users; if either panel is re-enabled
        // these will need to come from i18n.
        ariaLabels={{ navigation: 'Navigation', tools: 'Tools' }}
      />
    </>
  );
};

export default AppLayout;
